export const routes = {
    "/:taskId/immunisationBloodTestConsultation": {
        title: "Blood Test Consultation",
    },
    "/:taskId/bbvBloodTestConsultation": {
        title: "Blood Test Consultation",
    },
};
